import React from 'react';
import { Instagram, Music2, Send, Youtube } from 'lucide-react';
import './Footer.css';

const footerGroups = [
    {
        title: 'Покупателям',
        links: [
            { label: 'Проверка подлинности', href: '/help/authenticity' },
            { label: 'Возврат и претензии', href: '/help/returns' },
            { label: 'Доставка и таможня', href: '/help/delivery' },
            { label: 'Оплата и комиссия', href: '/help/payment' },
            { label: 'Как оформить заказ', href: '/help/how-to-order' },
            { label: 'Частые вопросы', href: '/help/faq' },
        ],
    },
    {
        title: 'О MERKULS',
        links: [
            { label: 'Политика обработки данных', href: '/legal/privacy' },
            { label: 'Агентская оферта', href: '/legal/agency-offer' },
            { label: 'Реквизиты компании', href: '/legal/details' },
            { label: 'Условия продажи', href: '/legal/sale-terms' },
            { label: 'О сервисе', href: '/about' },
        ],
    },
];

const socialLinks = [
    { label: 'Instagram', Icon: Instagram, href: 'https://www.instagram.com/merkuls_ru' },
    { label: 'Telegram', Icon: Send, href: 'https://t.me/merkuls_ru' },
    { label: 'TikTok', Icon: Music2, href: null },
    { label: 'YouTube', Icon: Youtube, href: null },
];

const Footer = () => (
    <footer className="site-footer">
        <div className="site-footer__shell">
            <div className="site-footer__identity">
                <a className="site-footer__brand" href="/" aria-label="Merkuls — на главную">
                    <img alt="" src="/img/svg/merkuls_logo.svg" />
                </a>
                <div className="site-footer__socials" aria-label="Социальные сети">
                    {socialLinks.map(({ label, Icon, href }) => (
                        <a
                            key={label}
                            className="site-footer__social-link"
                            href={href || '#'}
                            aria-label={label}
                            aria-disabled={!href}
                            rel={href ? 'noreferrer' : undefined}
                            target={href ? '_blank' : undefined}
                            onClick={!href ? (event) => event.preventDefault() : undefined}
                        >
                            <Icon aria-hidden="true" size={20} strokeWidth={1.5} />
                        </a>
                    ))}
                </div>
            </div>
            <nav className="site-footer__columns" aria-label="Нижняя навигация">
                {footerGroups.map((group) => (
                    <div className="site-footer__group" key={group.title}>
                        <h2 className="site-footer__group-title">{group.title}</h2>
                        <ul className="site-footer__links">
                            {group.links.map((link) => (
                                <li key={link.label}>
                                    <a href={link.href} className="site-footer__link">
                                        {link.label}
                                    </a>
                                </li>
                            ))}
                        </ul>
                    </div>
                ))}
            </nav>
        </div>
        <div className="site-footer__bottom">
            <div className="site-footer__bottom-inner site-footer__shell">
                <span>© {new Date().getFullYear()} MERKULS</span>
                <span>Россия · ₽ RUB</span>
            </div>
        </div>
    </footer>
);

export default Footer;
